import { CardTypeConfig } from '../../interfaces/card-type-config';

export const DEFAULT_CARD_TYPE_NAME = 'default';

export const DEFAULT_CARD_TYPE_CONFIG: CardTypeConfig = {
    niceType: 'DEFAULT',
    type: DEFAULT_CARD_TYPE_NAME,
    patterns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    gaps: [4, 8, 12],
    lengths: [12, 13, 14, 15, 16, 17, 18, 19],
    code: {
        name: 'CVV',
        size: 3
    }
};
